import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

import { UploadService } from 'src/@services/upload.service';

@Component({
  selector: 'ciwc-upload-media',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    NgIf,
    MatProgressSpinner,
  ],
  templateUrl: './upload-media.component.html',
  styleUrl: './upload-media.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadMediaComponent {
  @Input() attachment!: FormGroup;
  @Input() parentForm!: FormGroup;

  private uploadService = inject(UploadService);

  triggerFileInput() {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.attachment.patchValue({
        isUploading: true,
        uploadError: '',
      });
      this.uploadService.uploadFile(file).subscribe({
        next: (res) => {
          this.attachment.patchValue({
            attachmentDocument: res.name,
            url: res.url,
            isUploading: false,
            uploadError: '',
          });
        },
        error: (_err) => {
          this.attachment.patchValue({
            isUploading: false,
            uploadError: 'Failed to upload file. Please try again.',
          });
        },
      });
    }
  }

  viewAttachment() {
    const attachment = this.attachment.value;
    if (attachment.url) {
      window.open(attachment.url, '_blank');
      return;
    }
    const file = attachment.attachmentDocument;
    if (!file) return;
    if (file instanceof File) {
      // If it's a File object, create a blob URL
      const url = URL.createObjectURL(file);
      window.open(url, '_blank');
      // Optionally, revoke the object URL after some time
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } else if (typeof file === 'string') {
      // If it's a string (URL), open directly
      window.open(file, '_blank');
    }
  }
}
